/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../core/IceEntity';
import { IceTypes } from '../icetypes';
import { provider_reference } from '../domain/provider_reference';

export class appointment extends IceEntity {
    appointment_key: string = "";
    patient_trans_account: string = "";
    trans_account: string = "";
    account_type: IceTypes.ACCOUNT_TYPE = IceTypes.ACCOUNT_TYPE.actNone;
    recurrence_key: string = "";
    referral_from_key: string = "";
    appointment_status: IceTypes.appt_status = IceTypes.appt_status.apptstatNone;
    appointment_status_note: string = "";
    appointment_type: IceTypes.appt_type = IceTypes.appt_type.appttypeInitial;
    time_slot_start: any = NaN;
    time_slot_end: any = NaN;
    interval_type: IceTypes.interval = IceTypes.interval.interval15;
    slot_color: string = "";
    slot_font_color: string = "";
    multiple: boolean = false;
    subject: string = "";
    txt: string = "";
    reminder_key: string = "";
    record_version: number = 0;
    offline_record_status: number = 0;
    accessed: any = NaN;
    accessed_user: string = "";
    created: any = NaN;
    created_user: string = "";
    modified: any = NaN;
    modified_user: string = "";
    telehealth: boolean = false;
    telehealth_url: string = "";
  PROVS: provider_reference[] = [];

    gettablename(): string {
        return "APPOINTMENT";
    }

    hassubtree(ColumnName: string): boolean {
        if (ColumnName.length == 0) return false;
        else if (ColumnName == "PROVS") return true;
        else if (ColumnName == "USERS") return true;
        else if (ColumnName == "TASKS") return true;
        else if (ColumnName == "ENCS") return true;

        return false;
    }

    getsubtreetablename(ColumnName: string): string {
        if (ColumnName.length == 0) return null;
        else if (ColumnName == "PROVS") return "PROVIDER_REFERENCE";
        else if (ColumnName == "USERS") return "USER_TRANS_ACCOUNT";
        else if (ColumnName == "TASKS") return "TASK_REFERENCE";
        else if (ColumnName == "ENCS") return "ENCOUNTER_INDEX";

        return null;
    }
}

